'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIIconHolder = require('./UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

var _iconName = require('../utils/propTypes/iconName');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIIconCircle',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    backgroundColor: _react.PropTypes.string,
    borderColor: _react.PropTypes.string,
    borderStyle: _react.PropTypes.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
    borderWidth: _react.PropTypes.number,
    className: _react.PropTypes.string,
    innerStyles: _react.PropTypes.object,
    iconClassName: _react.PropTypes.string,
    name: (0, _iconName.getIconNamePropType)().isRequired,
    color: _react.PropTypes.string,
    size: _react.PropTypes.number,
    style: _react.PropTypes.object,
    padding: _react.PropTypes.number,
    legacy: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      borderWidth: 1,
      borderStyle: 'solid',
      padding: 0.75
    };
  },
  getBorderColor: function getBorderColor(borderColor, color) {
    if (borderColor) {
      return borderColor;
    }
    return color;
  },
  getPadding: function getPadding(padding, legacy) {
    return legacy ? 0 : padding;
  },
  render: function render() {
    var _props = this.props,
        backgroundColor = _props.backgroundColor,
        borderColor = _props.borderColor,
        borderStyle = _props.borderStyle,
        borderWidth = _props.borderWidth,
        className = _props.className,
        color = _props.color,
        iconClassName = _props.iconClassName,
        innerStyles = _props.innerStyles,
        legacy = _props.legacy,
        name = _props.name,
        padding = _props.padding,
        size = _props.size,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['backgroundColor', 'borderColor', 'borderStyle', 'borderWidth', 'className', 'color', 'iconClassName', 'innerStyles', 'legacy', 'name', 'padding', 'size', 'style']);

    var outerCircleClassNames = (0, _reactUtils.classNames)('private-icon-circle__outer', { 'private-icon-circle--legacy': legacy }, className);
    var innerCircleClassNames = (0, _reactUtils.classNames)('private-icon-circle__inner', iconClassName);
    return _react2.default.createElement(_UIIconHolder2.default, _extends({}, rest, {
      backgroundColor: backgroundColor,
      borderColor: this.getBorderColor(borderColor, color),
      borderRadius: '50%',
      borderStyle: borderStyle,
      borderWidth: borderWidth,
      className: outerCircleClassNames,
      innerClassName: innerCircleClassNames,
      size: size,
      padding: this.getPadding(padding, legacy),
      name: name,
      color: color,
      style: style,
      innerStyles: innerStyles,
      _fromUIIconCircle: true
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/icon/UIIconCircle.js
// module id = 331
// module chunks = 0